// The URL of one endpoint's details page (/pam/endpoint/endpointDetails).
// `?id=` names the endpoint, so a shared link or a second tab opens that
// endpoint rather than whichever one this browser last opened. `extra` is any
// other query, e.g. "defaultTab=gateway&setup=1".
export const endpointDetailsPath = (instanceId, extra = "") => {
  const q = [instanceId ? `id=${encodeURIComponent(instanceId)}` : "", extra].filter(Boolean).join("&");
  return `/pam/endpoint/endpointDetails${q ? `?${q}` : ""}`;
};
